import { handleBussinessTaxIDInput } from "../../../Utils/masks";
import { AddressFields } from "./AddressFields";

const inputClass =
  "individual-onboarding-input h-10 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-brand-dark outline-none transition focus:border-[#e7a73f] focus:ring-2 focus:ring-[#e7a73f]/20";

export const CompanyDataStep = ({
  company,
  onChange,
  onCompanyZipCodeChange,
  cepLoading,
  cepError,
}) => (
  <div className="space-y-3">
    <div className="grid gap-3 md:grid-cols-2">
      <label className="sm:col-span-2">
        <span className="mb-1 block text-xs font-medium text-gray-500">
          Razão social
        </span>
        <input
          className={inputClass}
          value={company.businessName}
          onChange={(e) => onChange((current) => ({ ...current, businessName: e.target.value }))}
          required
        />
      </label>
      <label className="sm:col-span-2">
        <span className="mb-1 block text-xs font-medium text-gray-500">CNPJ</span>
        <input
          className={inputClass}
          value={company.cnpj}
          onChange={(e) =>
            onChange((current) => ({
              ...current,
              cnpj: handleBussinessTaxIDInput(e.target.value),
            }))
          }
          placeholder="00.000.000/0000-00"
          inputMode="numeric"
          autoComplete="off"
          required
        />
      </label>
    </div>

    <div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
        Endereço da empresa
      </p>
      <AddressFields
        address={company.address}
        onChange={(nextAddress) =>
          onChange((current) => ({ ...current, address: nextAddress }))
        }
        onZipCodeChange={onCompanyZipCodeChange}
        cepLoading={cepLoading}
        cepError={cepError}
        idPrefix="company-address"
      />
    </div>
  </div>
);
